import { getTimeValue } from "@circle-react/helpers/dateTimeHelpers";
import { DateInput } from "@circleco/compass/components/DateInput";
import {
  TimeInput,
  type TimeValue,
} from "@circleco/compass/components/TimeInput";
import { Controller, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

import { ensureFuturePollCloseAt } from "./ensureFuturePollCloseAt";

const DEFAULT_TIME: TimeValue = { hours: 0, minutes: 0 };

const toDate = (value: unknown): Date | undefined => {
  if (value instanceof Date) return value;
  if (typeof value !== "string" && typeof value !== "number") return undefined;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

export const PollDuration = () => {
  const { control, watch } = useFormContext();
  const isPollDurationEnabled = watch("enable_poll_duration");

  if (!isPollDurationEnabled) {
    return null;
  }

  return (
    <Controller
      control={control}
      name="closes_at"
      render={({ field, fieldState }) => {
        const date = toDate(field.value);
        const timeValue: TimeValue = date ? getTimeValue(date) : DEFAULT_TIME;
        const errorMessage = fieldState.error?.message;

        return (
          <div className="flex flex-col gap-4 md:flex-row">
            <DateInput
              className="grow"
              disabledDays={{ before: new Date() }}
              error={errorMessage}
              icon="calendar"
              label={t(
                "tiptap.extensions.poll.settings.cutoff_date_placeholder",
              )}
              onChange={selectedDate => {
                if (!selectedDate) {
                  field.onChange(null);
                  return;
                }
                field.onChange(
                  ensureFuturePollCloseAt(
                    selectedDate,
                    timeValue,
                  ).toISOString(),
                );
              }}
              placeholder={t(
                "tiptap.extensions.poll.settings.cutoff_date_placeholder",
              )}
              value={date}
            />
            <div className="md:w-48">
              <TimeInput
                error={errorMessage}
                label={t(
                  "tiptap.extensions.poll.settings.cutoff_time_placeholder",
                )}
                onChange={time => {
                  const baseDate = date ?? new Date();
                  field.onChange(
                    ensureFuturePollCloseAt(baseDate, time).toISOString(),
                  );
                }}
                value={timeValue}
              />
            </div>
          </div>
        );
      }}
    />
  );
};
